import React from 'react';
import { getNextOccurrence } from '../../utils/dateUtils';
import './DaySelector.css';

const DaySelector = ({ onDaySelect, onCustomDateSelect, loading }) => {
  const days = [
    { name: 'Sunday', short: 'Sun', value: 0 },
    { name: 'Monday', short: 'Mon', value: 1 },
    { name: 'Tuesday', short: 'Tue', value: 2 },
    { name: 'Wednesday', short: 'Wed', value: 3 },
    { name: 'Thursday', short: 'Thu', value: 4 },
    { name: 'Friday', short: 'Fri', value: 5 },
    { name: 'Saturday', short: 'Sat', value: 6 }
  ];

  const handleDayClick = (dayOfWeek) => {
    if (loading) return;
    
    const nextOccurrence = getNextOccurrence(dayOfWeek);
    onDaySelect(nextOccurrence);
  };

  const handleCustomDateClick = () => {
    if (loading) return;
    onCustomDateSelect();
  };

  return (
    <div className="day-selector">
      <h4>Select a day to schedule this recipe:</h4>
      
      <div className="days-grid">
        {days.map((day) => (
          <button
            key={day.value}
            className="day-button"
            onClick={() => handleDayClick(day.value)}
            disabled={loading}
          >
            <span className="day-name">{day.name}</span>
            <span className="day-short">{day.short}</span>
          </button>
        ))}
      </div>

      <div className="custom-date-section">
        <button
          className="custom-date-button"
          onClick={handleCustomDateClick}
          disabled={loading}
        >
          Set Custom Date
        </button>
      </div>

      {loading && (
        <div className="loading-message">
          Scheduling recipe...
        </div>
      )}
    </div>
  );
};

export default DaySelector;